(function () {
	const footer = document.querySelector('.site-footer');
	if (!footer || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
	if (!('IntersectionObserver' in window)) return;

	footer.classList.add('f-anim');

	const observer = new IntersectionObserver((entries) => {
		if (!entries.some((entry) => entry.isIntersecting)) return;
		footer.classList.add('is-in');
		observer.disconnect();
	}, { rootMargin: '0px 0px -12% 0px' });

	observer.observe(footer);
})();
